import {AfterViewInit, Component, HostListener, OnDestroy, OnInit, TemplateRef, ViewChild,} from '@angular/core';
import { Location } from '@angular/common';
import {TaskOptionsService} from '../../../services/task-options.service';
import {AlertService} from '../../../services/notify/alert.service';
import {CrmService} from '../../../services/api/crm.service';
import {ModalService} from '../../../services/modal/modal.service';
import {ActivatedRoute, Router} from '@angular/router';
import {HelpersService} from '../../../services/helpers.service';
import {TaskServiceService} from '../../../services/task-service.service';
import {catchError, EMPTY, filter, Observable, switchMap} from 'rxjs';
import {ComponentCanDeactivate} from '../../../guards/save-guard';
import {TranslateService} from '@ngx-translate/core';
import { DialogsMTService, IconfirmDialogSettings } from '../../../services/modal/dialogs-mt.service';
import { MatDialog } from '@angular/material/dialog';
import { AppBoardMngtFormComponent } from '../forms/board-mngt-form/board-mngt-form';

@Component({
    selector: 'app-task-options',
    templateUrl: './task-options.component.html',
    styleUrls: ['./task-options.component.scss'],
})
export class TaskOptionsComponent implements OnInit, AfterViewInit, ComponentCanDeactivate, OnDestroy {
    @ViewChild('taskOptionsView') viewTaskOptions!: TemplateRef<any>;
    isShowIcons = false;
    icons = {
        selected: '',
        all: [
            'bi bi-alarm',
            'bi bi-archive',
            'bi bi-at',
            'bi bi-asterisk',
            'bi bi-bar-chart',
            'bi bi-bar-chart-steps',
            'bi bi-bell',
            'bi bi-box-seam',
            'bi bi-bricks',
            'bi bi-briefcase',
            'bi bi-buildings',
            'bi bi-calendar-date',
            'bi bi-camera',
            'bi bi-cash-stack',
            'bi bi-chat-dots',
            'bi bi-check2-all',
            'bi bi-easel',
            'bi bi-pen',
        ],
    };

    tab = 'statuses';

    constructor(
        public taskOptionsService: TaskOptionsService,
        public taskService: TaskServiceService,
        public alert: AlertService,
        public crmService: CrmService,
        public modalService: ModalService,
        public router: Router,
        private route: ActivatedRoute,
        public helper: HelpersService,
        public translate: TranslateService,
        private location:Location,
        private dialogsMTService: DialogsMTService,
        private dialog: MatDialog
    ) {
    }

    @HostListener('window: beforeunload', ['$event'])
    deactivate(): boolean {
        if (this.taskOptionsService.isPermissionsChanged) {
            return false;
        }
    }

    canDeactivate(): boolean | Observable<boolean> {
        if (this.taskOptionsService.isPermissionsChanged) {
            return confirm(this.translate.instant('CONFIRM.TEXT.LEAVE_PAGE'));
        } else {
            return true;
        }
    }

    ngOnInit(): void {
        this.route.params.subscribe((param: any) => {
            this.tab = param.prop;
        });
    }

    ngAfterViewInit(): void {
        const sub = this.route.queryParams.subscribe(param => {
            if (param.alias) {
                this.taskOptionsService.init();
            } else {
                this.taskOptionsService.onLoadBoards(true).then(() => {
                    this.modalService.openTemplateModal(this.viewTaskOptions);
                });
            }
        });

        sub.unsubscribe();
    }

    ngOnDestroy(): void {
        this.taskOptionsService.selectedBoard = null;
    }
   	navToRoute (route:string[],params?:any) {
      this.router.navigate(route, {queryParams:params});
    }
    navBack() {
       this.location.back();
    }
    onCopyBoardOpen() {
        let ref = this.dialog.open(AppBoardMngtFormComponent)
        ref.componentInstance.aliasesTaken = this.taskOptionsService?.boardsForOptions.map(el=>el.alias)
    }
    deleteBoard(): void {
        if (!this.taskOptionsService?.selectedBoard?.alias) {
            return
        }
        let dialogSettings:IconfirmDialogSettings = {
            actionHeader: 'CONFIRM.HEADERS.DELETE',
            actionBody: 'CONFIRM.TEXT.DELETE_BP'
        }
        let board = this.taskOptionsService?.selectedBoard?.alias
        this.dialogsMTService.confirmDialog(dialogSettings)
        .pipe(
            filter(res => res?.isConfirmed),
            switchMap(() => this.crmService.deleteBoardById(board,this.taskOptionsService.selectedBoard?.is_archived !== true).pipe(
                catchError((err) => {
                    this.alert.setAlert(err.message, 'blue');
                    return EMPTY
                }))
            ),
            catchError(() => {
                return EMPTY
            }))
        .subscribe(()=>{
            this.alert.setAlert(this.translate.instant('ALERTS.SUCCESS'), 'nd_color');
            void this.router.navigate([], {queryParams: null});
            void this.taskOptionsService.onLoadBoards(true);
            this.taskOptionsService.selectedBoard = null;
            this.modalService.openTemplateModal(this.viewTaskOptions);

        }) 
    }
    openTable(): void {
        void this.router.navigate(['account', 'tasks', 'all', this.taskOptionsService.selectedBoard.alias]);
    }

    navigateProp(prop): void {
        void this.router.navigate(['account', 'tasks', 'options', prop], {
            queryParams: {alias: this.taskOptionsService.selectedBoard.alias},
        });
    }

}
